import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CATEGORIES, CATEGORY_LABELS, monthName } from "@/lib/format";
import { SiteLayout } from "@/components/site/SiteLayout";
import { ArticleCard } from "@/components/site/ArticleCard";

export default function Archive() {
  const [months, setMonths] = useState([]);
  const [sel, setSel] = useState(null); // {year, month}
  const [category, setCategory] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/archives/months").then((r) => {
      setMonths(r.data);
      if (r.data.length) setSel({ year: r.data[0].year, month: r.data[0].month });
    });
  }, []);

  useEffect(() => {
    if (!sel) return;
    setLoading(true);
    api.get("/articles", { params: { year: sel.year, month: sel.month, category: category || undefined, limit: 100 } })
      .then((r) => setItems(r.data.items))
      .finally(() => setLoading(false));
  }, [sel, category]);

  return (
    <SiteLayout>
      <div className="max-w-[1240px] mx-auto px-4 py-8">
        <header className="border-b-2 border-prussian pb-4 mb-8">
          <h1 className="font-headline font-black text-prussian text-4xl md:text-5xl tracking-tight">Archiv</h1>
          <p className="text-sm text-muted-foreground font-body mt-2">Alle Ausgaben nach Monat und Rubrik.</p>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <aside className="lg:col-span-1 space-y-6">
            <div>
              <h2 className="font-body font-bold uppercase text-xs tracking-wider text-prussian mb-3">Rubrik</h2>
              <div className="flex flex-wrap gap-2">
                <button onClick={() => setCategory("")} data-testid="archive-cat-all"
                  className={`text-xs font-body uppercase tracking-wide px-3 py-1.5 border ${category === "" ? "bg-prussian text-white border-prussian" : "bg-white border-edborder text-prussian"}`}>Alle</button>
                {CATEGORIES.map((c) => (
                  <button key={c} onClick={() => setCategory(c)} data-testid={`archive-cat-${c}`}
                    className={`text-xs font-body uppercase tracking-wide px-3 py-1.5 border ${category === c ? "bg-prussian text-white border-prussian" : "bg-white border-edborder text-prussian"}`}>{CATEGORY_LABELS[c]}</button>
                ))}
              </div>
            </div>
            <div>
              <h2 className="font-body font-bold uppercase text-xs tracking-wider text-prussian mb-3">Zeitraum</h2>
              <ul className="space-y-1">
                {months.map((m) => {
                  const active = sel && sel.year === m.year && sel.month === m.month;
                  return (
                    <li key={`${m.year}-${m.month}`}>
                      <button onClick={() => setSel({ year: m.year, month: m.month })}
                        data-testid={`archive-month-${m.year}-${m.month}`}
                        className={`w-full text-left flex justify-between items-center px-3 py-2 text-sm font-body ${active ? "bg-prussian text-white" : "bg-white border border-edborder text-charcoal hover:border-prussian"}`}>
                        <span>{monthName(m.month)} {m.year}</span>
                        <span className={`text-xs ${active ? "text-white/70" : "text-muted-foreground"}`}>{m.count}</span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          </aside>

          <div className="lg:col-span-3">
            {sel && <h2 className="font-headline font-bold text-2xl text-prussian mb-6">{monthName(sel.month)} {sel.year}{category ? ` · ${CATEGORY_LABELS[category]}` : ""}</h2>}
            {loading ? <p className="text-muted-foreground font-body">Lädt…</p> : items.length === 0 ? (
              <p className="text-muted-foreground font-body py-12 text-center">Keine Artikel in diesem Zeitraum.</p>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                {items.map((a) => <ArticleCard key={a.id} article={a} />)}
              </div>
            )}
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
